import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AuthSuccess.css';

const AuthSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkSession } = useAuth();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Authenticating...');

  useEffect(() => {
    const handleAuth = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('No authentication token received');
        setTimeout(() => navigate('/?error=no_token'), 2000);
        return;
      }

      try {
        // Store token in localStorage
        localStorage.setItem('authToken', token);
        
        // Use AuthContext to check session and load user data
        await checkSession();
        
        setStatus('success');
        setMessage('Login successful! Redirecting...');
        
        // Redirect to dashboard
        setTimeout(() => navigate('/dashboard'), 1500);
      } catch (error) {
        console.error('Authentication error:', error);
        setStatus('error');
        setMessage('Authentication failed. Please try again.');
        localStorage.removeItem('authToken');
        setTimeout(() => navigate('/?error=auth_failed'), 2000);
      }
    };

    handleAuth();
  }, [searchParams, navigate, checkSession]);

  return (
    <div className="auth-success-container">
      <div className="auth-success-card">
        {status === 'loading' && (
          <>
            <div className="spinner"></div>
            <h2>{message}</h2>
            <p>Please wait while we log you in...</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="success-icon">✓</div>
            <h2>{message}</h2>
            <p>Welcome to Global Sansys!</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="error-icon">✕</div>
            <h2>{message}</h2>
            <p>Redirecting to home page...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthSuccess;
